import {Component, Inject, OnInit} from '@angular/core';
import {DialogConfigBase} from '../dialog-config-base';
import {DialogConfigInterface} from '../dialog-config.interface';
import {MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef} from '@angular/material';
import {logoUrl} from '../../../../core/utils/utils';
import {AssetsService} from '../../../services/assets.service';

@Component({
  selector: 'app-driver-sos-details-dialog',
  templateUrl: './driver-sos-details-dialog.component.html',
  styleUrls: ['./driver-sos-details-dialog.component.scss']
})
export class DriverSosDetailsDialogComponent implements OnInit {

  get rightImageUrl(): string {
    return './assets/images/banners/sos_popup.svg';
  }

  get logoSosUrl(): string {
    return './assets/images/banners/logo_sos.png';
  }

  get logoUrl(): string {
    return logoUrl();
  }

  get checkIconUrl(): string {
    return `${this.assetsService.getIconsDirectoryPath()}/check.svg`;
  }

  static getConfigBuilder(): any {
    return new DriverSosDetailsDialogConfig();
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private assetsService: AssetsService,
              private dialog: MatDialogRef<DriverSosDetailsDialogComponent>) { }

  ngOnInit() {
  }

  close() {
    this.dialog.close();
  }

}

export class DriverSosDetailsDialogConfig extends DialogConfigBase implements DialogConfigInterface {

  private config: MatDialogConfig = {
    panelClass: 'driver-sos-details-dialog-panel'
  };

  constructor() {
    super();
  }

  buildConfiguration(data: any): MatDialogConfig {
    return this.buildConfig(data, this.config);
  }
}
